module.exports = __webpack_public_path__ + "static/media/male-voice.3927fae4.svg";